import { useTranslation } from 'react-i18next'
import { CitationBadge } from 'components/ui/CitationBadge'
import { AgentView } from 'types/agent'
import { analytics, ANALYTICS_EVENTS } from 'services/analytics'

type ViewResultLinkProps = {
  view: AgentView
}

export const ViewResultLink = ({ view }: ViewResultLinkProps) => {
  const { t } = useTranslation()

  const openResult = () => {
    analytics.track(ANALYTICS_EVENTS.VIEW_RESULT_CLICKED)
    window.parent.postMessage(
      {
        type: 'navigateToResult',
        payload: { routeName: view.routeName, params: view.params, pathTemplate: view.pathTemplate },
      },
      '*',
    )
  }

  return (
    <button
      type="button"
      onClick={openResult}
      className="flex min-h-[24px] cursor-pointer items-center gap-1.5 py-1 text-xs text-foreground transition-colors hover:text-primary hover:underline"
    >
      {view.citationNum != null && <CitationBadge label={String(view.citationNum)} size="sm" />}
      <span className="truncate">{view.label ?? t('viewResult')}</span>
    </button>
  )
}
